export var GenderType;
(function (GenderType) {
    GenderType["MALE"] = "MALE";
    GenderType["FEMALE"] = "FEMALE";
    GenderType["OTHER"] = "OTHER";
})(GenderType || (GenderType = {}));
export const genderOptions = [
    { id: GenderType.MALE, name: 'Male' },
    { id: GenderType.FEMALE, name: 'Female' },
    { id: GenderType.OTHER, name: 'Other' }
];
//# sourceMappingURL=gender.interfaces.js.map